"use strict";

import angular from "angular";

import _ from "lodash";
import { CompanyEntity } from "../../entity/CompanyEntity";

export class CompanyDataService {
    entity = null;

    constructor() {}

    set(companyData) {
        this.entity = CompanyEntity.restore(companyData);
    }

    get() {
        return this.entity;
    }

    setAttribute(path, value) {
        _.set(this.entity.props, path, value);
    }
}

angular.module("nucont.shared").service("CompanyDataService", CompanyDataService);
